import React, {
  useCallback,
  memo,
  useContext,
  useState,
  useEffect,
  Fragment,
} from "react";
import {
  Container,
  Row,
  Col,
  ButtonGroup,
  Button,
  Form,
  ListGroup,
  Navbar,
  Image,
} from "react-bootstrap";
import { animateScroll as scroll } from "react-scroll";
import { FiArrowUp, FiRefreshCw } from "react-icons/fi";
import { formatMenuData } from "../Services/FormatMenu";
import Collapsible from "react-collapsible";
import { HashLink as Link } from "react-router-hash-link";
import { ReactComponent as BookMarkDarkIcon } from "../bookmark-dark.svg";
import { ReactComponent as BookMarkLightIcon } from "../bookmark-light.svg";
import { ReactComponent as BookMarkListIcon } from "../bookmark-list.svg";
import { StoreContext } from "../Stores";
import { TYPES } from "../Reducers/bookmarkReducer";
import { updateTextStyles } from "../Services/FormatMenu";
import { withRouter } from "react-router";
import useDebounce from "../hooks/useDebounce";
import { isEqual } from "lodash";
import ItemModal from "./ItemModal";

const convertMenuItemToLink = (item) => {
  const str =
    item.name + item?.vintage || "" + item?.format || "" + item?.price || "";
  return encodeURI(
    str
      .trim()
      .split(/\s*(?:,|$)\s*/)
      .join("-")
  );
};

const MenuItemLayoutDefault = ({
  isBookmarked,
  handleUnBookmark,
  handleBookmark,
  normalTextStyle,
  anchorLink,
  item,
  defaultTextColor,
  subtextStyle,
  defaultTextPriceColor,
  currencySymbol,
  bookmarksEnabled,
}) => {
  const onBookmark = () => {
    handleBookmark();
  };

  const onUnBookmark = () => {
    handleUnBookmark();
  };

  return (
    <Col
      xs="12"
      className="px-0 mt-2 mb-2 pb-3"
      style={{ borderBottom: "1px solid #ddd" }}
    >
      <div className="d-flex justify-content-between">
        <div style={normalTextStyle} className="d-flex">
          <span style={{ width: 20 }} className="pl-2 mr-2">
            {bookmarksEnabled && (
              <>
                {isBookmarked ? (
                  <BookMarkDarkIcon
                    className="bookmark-icon"
                    onClick={onUnBookmark}
                  />
                ) : (
                  <BookMarkLightIcon
                    className="bookmark-icon"
                    onClick={onBookmark}
                  />
                )}
              </>
            )}
          </span>

          <div>
            <span name={anchorLink} id={anchorLink}>
              {item.name}
            </span>
            &nbsp;
            <span
              style={{
                color: defaultTextColor,
                ...subtextStyle,
              }}
            >
              {item.vintage}
            </span>
            &nbsp;
            <span
              style={{
                color: defaultTextColor,
                ...subtextStyle,
              }}
            >
              {item.format}
            </span>
          </div>
        </div>
        <div className="pl-2 pr-2">
          <span
            className="font-italic"
            style={{
              color: defaultTextPriceColor,
              ...normalTextStyle,
            }}
          >
            {currencySymbol}
            {item.price}
          </span>
        </div>
      </div>
    </Col>
  );
};

const MenuItemLayoutImages = ({
  isBookmarked,
  handleUnBookmark,
  handleBookmark,
  normalTextStyle,
  anchorLink,
  item,
  defaultTextColor,
  subtextStyle,
  defaultTextPriceColor,
  currencySymbol,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onBookmark = () => {
    handleBookmark();
  };

  const onUnBookmark = () => {
    handleUnBookmark();
  };

  const handleDisplayModal = () => {
    setShowModal((prevState) => !prevState);
    console.log("here");
  };

  return (
    <Col xs="12" md="12" lg="6">
      <ItemModal
        show={showModal}
        item={item}
        setShowModal={setShowModal}
        defaultTextColor={defaultTextColor}
        subtextStyle={subtextStyle}
        defaultTextPriceColor={defaultTextPriceColor}
        normalTextStyle={normalTextStyle}
        currencySymbol={currencySymbol}
      />
      <div className="mt-2 mb-2 menu-item-card">
        <div
          className="menu-bookmark mb-2"
          style={{ left: "2px", top: "10px" }}
        >
          {isBookmarked ? (
            <BookMarkDarkIcon
              className="bookmark-icon"
              onClick={onUnBookmark}
            />
          ) : (
            <BookMarkLightIcon className="bookmark-icon" onClick={onBookmark} />
          )}
        </div>
        <div
          className="row no-gutters"
          onClick={handleDisplayModal}
          style={{ cursor: "pointer" }}
        >
          <div className="col">
            <div className="card-block px-2">
              <h5 className="card-title" style={{ marginBottom: 0 }}>
                <span
                  name={anchorLink}
                  id={anchorLink}
                  className="truncate-text"
                  style={{
                    color: defaultTextPriceColor,
                    ...normalTextStyle,
                  }}
                >
                  {item.name}
                </span>
              </h5>
              <p
                style={{
                  marginBottom: 0,
                  color: defaultTextColor,
                  ...subtextStyle,
                }}
                className="truncate-text mt-1 pr-3"
              >
                {`${item?.vintage || ""} ${item?.format || ""}`}
              </p>
              <p
                className="font-italic"
                style={{
                  color: defaultTextPriceColor,
                  ...normalTextStyle,
                }}
              >
                {currencySymbol}
                {item.price}
              </p>
            </div>
          </div>
          {item.imageUrl && (
            <div className="col-3">
              <Image
                src={item.imageUrl}
                fluid
                rounded
                className="card-img-top"
              />
            </div>
          )}
        </div>
      </div>
      <hr></hr>
    </Col>
  );
};

const MenuItem = memo(
  (props) => {
    console.log("props MenuItem:" + props?.bookmarksEnabled);
    const { item, menuLayout } = props;

    const defaultTextColor = "#6C757D";
    const defaultTextPriceColor = "#000000";

    const anchorLink = convertMenuItemToLink(item);

    if (menuLayout === "WITH_IMAGES") {
      return (
        <MenuItemLayoutImages
          {...props}
          anchorLink={anchorLink}
          defaultTextColor={defaultTextColor}
          defaultTextPriceColor={defaultTextPriceColor}
        />
      );
    }

    return (
      <MenuItemLayoutDefault
        {...props}
        anchorLink={anchorLink}
        defaultTextColor={defaultTextColor}
        defaultTextPriceColor={defaultTextPriceColor}
      />
    );
  },

  (prevProps, nextProps) => {
    return (
      isEqual(prevProps.item, nextProps.item) &&
      prevProps.isBookmarked === nextProps.isBookmarked &&
      prevProps.menuLayout === nextProps.menuLayout
    );
  }
);

const MenuItemContainer = memo((props) => {
  const { menuId, menuName, item, hashLocation, menuIndex } = props;
  const contextValue = useContext(StoreContext);
  const { state, dispatch } = contextValue;
  const dispatchCallback = React.useCallback(dispatch, []);
  const getBookmarkedMenu = state?.bookmark[menuId];
  const anchorLink = convertMenuItemToLink(item);

  useEffect(() => {
    /**
     * Auto Scroll to the menu section-index
     */
    if (hashLocation) {
      const elem = document.getElementById(hashLocation.substring(1));

      if (elem) {
        elem.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
        elem.classList.add("highlight-section");

        setTimeout(function () {
          elem.classList.remove("highlight-section");
        }, 5000);
      }
    }
  }, [hashLocation]);

  // Checking is item already bookmarked
  const isBookmarked = React.useMemo(() => {
    /**
     * Get the bookmarked menu
     * if the bookmarked menu exist -> checking menu's item is bookmarked or not
     * */

    // Find the bookmarked menu's item
    if (getBookmarkedMenu) {
      const menuListBookmarked = getBookmarkedMenu.bookmarks;
      const findBookmark = menuListBookmarked.find(
        (bookmark) => bookmark.path.toLowerCase() === anchorLink.toLowerCase()
      );

      return !!findBookmark;
    }

    return false;
  }, [anchorLink, getBookmarkedMenu]);

  const handleBookmark = React.useCallback(() => {
    dispatch({
      type: TYPES.ADD_BOOKMARK,
      menu: {
        name: menuName,
        id: menuId,
        bookmarkPath: anchorLink,
        bookmarkItem: item,
        menuIndex,
      },
    });
  }, [anchorLink, dispatch, item, menuId, menuIndex, menuName]);

  const handleUnBookmark = React.useCallback(() => {
    dispatch({
      type: TYPES.REMOVE_BOOKMARK,
      bookmark: {
        menuId,
        bookmarkPath: anchorLink,
      },
    });
  }, [anchorLink, dispatch, menuId]);

  return (
    <MenuItem
      {...props}
      isBookmarked={isBookmarked}
      dispatch={dispatchCallback}
      handleUnBookmark={handleUnBookmark}
      handleBookmark={handleBookmark}
    />
  );
});

const FormSearchMenu = memo(({ handleSearch, activeTab }) => {
  const [searchText, setSearchText] = useState("");

  const onChange = (e) => {
    setSearchText(e.target.value);
  };
  const debouncedSearchText = useDebounce(searchText, 500);

  useEffect(() => {
    // Reset search value if change active tab
    // Using "null" as reset action, "empty string" as clear input value action
    setSearchText(null);
  }, [activeTab]);

  useEffect(() => {
    handleSearch(debouncedSearchText);
  }, [handleSearch, debouncedSearchText]);

  // Do nothing when submit search.
  const searchFormSubmit = (e) => e.preventDefault();

  return (
    <Form role="search" aria-label="search" onSubmit={searchFormSubmit}>
      <Form.Control
        id="search"
        placeholder="Search"
        onChange={onChange}
        size="lg"
        value={searchText || ""}
        autoComplete="search-input"
      />
    </Form>
  );
});

const SectionMain = memo(
  ({ displayList, children }) => (
    <section role="main">{children(displayList)}</section>
  ),
  (prevProps, nextProps) => prevProps.displayList === nextProps.displayList
);

const MenuListDetailTab = withRouter(
  memo(
    ({
      fullJson,
      tocList = [],
      children,
      activeTab,
      history,
      loadSectionOnly,
    }) => {
      const [search, setSearch] = useState({
        searchText: "",
        wasSearched: false,
      });
      const [displayList, setDisplayList] = useState([]);
      const [pagination, setPagination] = useState({
        totalPages: 0,
        currentPage: 0,
      });

      const handleSearch = useCallback((searchText) => {
        if (searchText === null) {
          setSearch({ wasSearched: false, searchText: "" });
          return;
        }
        setSearch({ wasSearched: true, searchText });
      }, []);

      const handleLoadMore = React.useCallback(() => {
        // Clear the hash location prevent auto scroll to anchor-link
        if (history.location.hash !== "") {
          history.location.hash = "";
          window.history.pushState("", "", "#");
        }

        /**
         * When user search menu list, all menu items were load so
         * don't execute load-more when user search the menus list
         */
        if (search.wasSearched) {
          return;
        }

        setPagination((prevState) => {
          if (prevState.currentPage < prevState.totalPages) {
            const currentPage = prevState.currentPage + 1;
            const firstItemIndex = currentPage * 3;

            setDisplayList((prevList) => {
              let temp = [];

              if (tocList[firstItemIndex]) {
                temp.push(tocList[firstItemIndex]);
              }
              if (tocList[firstItemIndex + 1]) {
                temp.push(tocList[firstItemIndex + 1]);
              }

              if (tocList[firstItemIndex + 2]) {
                temp.push(tocList[firstItemIndex + 2]);
              }

              return [...prevList, ...temp];
            });

            return {
              ...prevState,
              currentPage,
            };
          }

          return prevState;
        });
      }, [history.location.hash, search.wasSearched, tocList]);

      useEffect(() => {
        if (search.wasSearched) {
          setDisplayList(
            formatMenuData(
              fullJson.filter((item) => {
                const keyword = search.searchText.toLowerCase();
                return (
                  (item?.name &&
                    item.name.toString().toLowerCase().indexOf(keyword) > -1) ||
                  (item?.header1 &&
                    item.header1.toString().toLowerCase().indexOf(keyword) >
                      -1) ||
                  (item?.header2 &&
                    item.header2.toString().toLowerCase().indexOf(keyword) >
                      -1) ||
                  (item?.header3 &&
                    item.header3.toString().toLowerCase().indexOf(keyword) >
                      -1) ||
                  (item?.header4 &&
                    item.header4.toString().toLowerCase().indexOf(keyword) >
                      -1) ||
                  (item?.vintage &&
                    item.vintage.toString().toLowerCase().indexOf(keyword) >
                      -1) ||
                  (item?.format &&
                    item.format.toString().toLowerCase().indexOf(keyword) > -1)
                );
              })
            )
          );
          return;
        }
      }, [fullJson, search, search.searchText, search.wasSearched]);

      useEffect(() => {
        setPagination({
          totalPages: parseInt(tocList.length / 3),
          currentPage: 0,
        });

        setDisplayList(() => {
          let temp = [];
          if (tocList[0]) {
            temp.push(tocList[0]);
          }

          if (tocList[1]) {
            temp.push(tocList[1]);
          }

          if (tocList[2]) {
            temp.push(tocList[2]);
          }
          if (loadSectionOnly) return [...temp];
          else return formatMenuData(fullJson);
        });
      }, [tocList, fullJson, loadSectionOnly]);

      useEffect(() => {
        if (activeTab === "toc") {
          setSearch({ searchText: "", wasSearched: false });
          return;
        }
      }, [activeTab]);

      return (
        <>
          <Navbar
            expand="lg"
            sticky="top"
            bg="white"
            className="noprint mt-0 px-0 row"
            role="navigation"
            aria-label="Primary navigation"
          >
            <Col xs={12}>
              <FormSearchMenu
                handleSearch={handleSearch}
                activeTab={activeTab}
              />
            </Col>
          </Navbar>
          <SectionMain displayList={displayList}>{children}</SectionMain>
          {pagination.currentPage < pagination.totalPages &&
            !search.wasSearched &&
            loadSectionOnly && (
              <Button
                style={{
                  // The answer why using overflow-anchor css property: https://support.google.com/chrome/thread/62861011?hl=en
                  overflowAnchor: "none",
                }}
                variant="primary"
                block
                onClick={handleLoadMore}
              >
                Load more
              </Button>
            )}
        </>
      );
    },

    (prevProps, nextProps) => {
      return (
        prevProps.fullJson === nextProps.fullJson &&
        prevProps.activeTab === nextProps.activeTab &&
        prevProps.tocList === nextProps.tocList
      );
    }
  )
);

/**
 * Helper function to generate an anchor tag for each section/subsection
 * Abstracted function ensures the same anchor tag is generated in TOC and referenced in actual menu list as long as both calls this function
 *
 * Anchor tag naming strategy: #<parent title>-<parent style>-<current section title>-<current section style>
 *  i.e. "#THE%20UNITED%20STATES-header2-Virginia-header3"
 *
 * NOTE: assumes parent+child combination is unique enough for the entire menu list
 * @param {*} parentSection
 * @param {*} currentSection
 */
const generateAnchorTag = (parentSection, currentSection) => {
  var anchorLink = "";
  if (parentSection) {
    anchorLink += parentSection.title + "-" + parentSection.style + "-";
  }
  anchorLink += currentSection.title + "-" + currentSection.style;
  return encodeURI(anchorLink.trim());
};

/**
 * Returns h element by field, by default return p
 * @param {string} field
 */
const customHeader = (field) => {
  let header = "p";

  switch (field) {
    case "header1":
      header = "h1";
      break;

    case "header2":
      header = "h2";
      break;

    case "header3":
      header = "h3";
      break;

    case "header4":
      header = "h4";
      break;

    case "header5":
      header = "h5";
      break;

    case "header6":
      header = "h6";
      break;

    default:
      header = "p";
      break;
  }

  return header;
};

const TableOfContentTab = memo(
  ({ tocList, renderingStyleForText, history, menuId }) => {
    /**
     * Helper function to convert string to Title case
     * @param {*} str
     */
    const toTitleCase = (str) => {
      str = str.toLowerCase().split(" ");
      for (var i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
      }
      str = str.join(" ");

      const indexes = [];

      for (let i = 0; i < str.length; i++) {
        if (str[i] === '-') {
          indexes.push(i);
        }
      }
      for (const x of indexes) {
        console.log(x);
        str = str.substring(0,x+1) + str.charAt(x+1).toUpperCase() +  str.substring(x + 2);
      }
  
      return str;
    };

    /**
     * Helper function to generate TOC text
     * Header1 and Header2 are Uppercase
     * Header 3 and lower are Title case
     * @param {*} title
     * @param {*} style
     */
    const getTocHeaderTitle = useCallback((title = '', style) => {
      const titleFormat = title.toString()
      if (style !== "header3" && style !== "header4") {
        return titleFormat.toUpperCase();
      } else {
        return toTitleCase(titleFormat);
      }
    }, []);

    const GetTocHeader = ({
      parentSection,
      currentSection,
      onTocHeaderClick,
    }) => {
      const anchorLink = generateAnchorTag(parentSection, currentSection);
      const CustomHeader = customHeader(currentSection?.style);

      const handleScrollHighlight = (el) => {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });

        el.classList.add("highlight-section");

        setTimeout(function () {
          el.classList.remove("highlight-section");
        }, 5000);
      };

      /**
       * Handle when TOC header click, prevent default and stop propagation
       * Pass 'anchorLink' to help auto-scroll to selected TOC header item
       */
      const onTocMenuClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        // Pass the anchorLink when TOC header was selected
        onTocHeaderClick(anchorLink);
      };

      return (
        <div>
          <div className="toc_title" aria-label="Table of Contents" role="main">
            <Link
              scroll={handleScrollHighlight}
              to={"#" + anchorLink}
              onClick={onTocMenuClick}
              aria-label={`Link to ${currentSection.title}`}
            >
              <CustomHeader
                className={currentSection.style}
                style={renderingStyleForText(currentSection.style)}
                aria-label={currentSection.style}
              >
                {getTocHeaderTitle(currentSection.title, currentSection.style)}
              </CustomHeader>
            </Link>
          </div>
          <div>
            {/* empty div so that there isn't just a single div with a href tag */}
          </div>
        </div>
      );
    };

    /**
     * Recursive function that loops through tree/child nodes to render H1/H2/H3 headings for the Table of content
     * @param {*} parentSection
     * @param {*} currentSection
     * @param {int} index
     * @param {boolean}  isPrintVersion
     */
    const createToc = (
      parentSection,
      currentSection,
      index,
      isPrintVersion,
      onTocHeaderClick
    ) => {
      // Only render Collapsible section if Header style is header1 or header2, or if header has no subsections
      if (
        currentSection.section === undefined ||
        (currentSection.style !== "header1" &&
          currentSection.style !== "header2")
      ) {
        return (
          <Fragment key={currentSection.title + "-" + index}>
            <GetTocHeader
              parentSection={parentSection}
              currentSection={currentSection}
              onTocHeaderClick={onTocHeaderClick}
            />
          </Fragment>
        );
      } else {
        return (
          <Fragment key={currentSection.title + "-" + index}>
            {!isPrintVersion && (
              <Collapsible
                trigger={
                  <GetTocHeader
                    parentSection={parentSection}
                    currentSection={currentSection}
                    onTocHeaderClick={onTocHeaderClick}
                  />
                }
                aria-label="Collapse menu"
                title="Collapsible meu items"
              >
                {currentSection.section.map((subSection, index) =>
                  createToc(
                    currentSection,
                    subSection,
                    index,
                    isPrintVersion,
                    onTocHeaderClick
                  )
                )}
              </Collapsible>
            )}
          </Fragment>
        );
      }
    };

    return (
      <>
        <p className="lead font-weight-bold print-only mb-4">
          <u>Table of Contents</u>
        </p>
        <div className="noprint" role="main">
          {
            /* TOC with sub headers as Collapsible components */
            tocList !== undefined &&
              tocList.map((section, index) => {
                const onTocHeaderClick = (anchorLink) => {
                  // Push to Menu-section view with anchorLink
                  history.push(
                    `/${menuId}/${index}${anchorLink ? `#${anchorLink}` : ""}`
                  );
                };

                return (
                  <Fragment key={section.title + "-" + index}>
                    <ListGroup
                      aria-label="tableOfContents"
                      variant="flush"
                      className="toc"
                      style={{ position: "relative" }}
                    >
                      {createToc(
                        undefined,
                        section,
                        index,
                        false,
                        onTocHeaderClick
                      )}
                    </ListGroup>
                  </Fragment>
                );
              })
          }
        </div>

        {/* Print only version of TOC that has expanded headers */}
        <div className="print-toc" role="main">
          {
            /* TOC with sub headers as Collapsible components */
            tocList !== undefined &&
              tocList.map((section, index) => (
                <Fragment key={section.title + "-" + index}>
                  <ListGroup
                    aria-label="Collapsible Table of Contents"
                    variant="flush"
                    className="toc"
                    style={{ position: "relative" }}
                  >
                    {createToc(undefined, section, index, true)}
                  </ListGroup>
                </Fragment>
              ))
          }
        </div>
      </>
    );
  }
);

const DisplayMenu = memo((props) => {
  const [activeTab, setActiveTab] = useState("toc");
  const hashLocation = props.location.hash;
  const scrollToTop = () => {
    scroll.scrollToTop();
  };

  /**
   * Function to add styles for text by settings
   * @param {string} field
   */
  const renderingStyleForText = useCallback(
    (field) => {
      const {
        headerOne,
        headerTwo,
        headerThree,
        headerFour,
        normalText,
        subtext,
      } = props;
      let textStyles = {};

      switch (field) {
        case "header1":
          textStyles = updateTextStyles(headerOne);
          break;

        case "header2":
          textStyles = updateTextStyles(headerTwo);
          break;

        case "header3":
          textStyles = updateTextStyles(headerThree);
          break;

        case "header4":
          textStyles = updateTextStyles(headerFour);
          break;

        case "subtext":
          textStyles = updateTextStyles(subtext);
          break;

        default:
          textStyles = updateTextStyles(normalText);
          break;
      }

      return textStyles;
    },
    [props]
  );

  const createItemsList = React.useCallback(
    (items, menu, menuIndex, bookmarksEnabled) => {
      if (items === undefined) {
        return;
      }

      return items.map((item, index) => {
        return (
          <MenuItemContainer
            key={item.name + index}
            menuId={menu.id}
            menuName={menu.name}
            menuLayout={menu.menuLayout}
            subtextStyle={renderingStyleForText("subtext")}
            normalTextStyle={renderingStyleForText("normal")}
            item={item}
            currencySymbol={props.currencySymbol}
            hashLocation={hashLocation}
            menuIndex={menuIndex}
            bookmarksEnabled={bookmarksEnabled}
          />
        );
      });
    },
    [hashLocation, props.currencySymbol, renderingStyleForText]
  );

  /**
   * Recursive function to generate the menu
   * @param {*} parentSection
   * @param {*} currentSection
   * @param {*} index
   * @param {*} menu
   */
  const createSection = React.useCallback(
    (parentSection, currentSection, menu, menuIndex, bookmarksEnabled) => {
      var anchorLink = generateAnchorTag(parentSection, currentSection);
      const CustomHeader = customHeader(currentSection?.style);

      const handleScroll = (el) => {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      };

      const sectionContent = (
        <Col xs={12}>
          <Link
            className="d-flex align-items-center mt-3 mb-3 sectionAnchor"
            key={anchorLink}
            name={currentSection.title}
            id={anchorLink}
            aria-label={`Link to ${currentSection.title}`}
            to={`#${anchorLink}`}
            scroll={handleScroll}
          >
            <div className="sectionAnchor">
              <CustomHeader
                className={currentSection.style}
                style={renderingStyleForText(currentSection.style)}
                aria-label={currentSection.style}
              >
                {currentSection.title}
              </CustomHeader>
            </div>
          </Link>
        </Col>
      );

      if (currentSection.section === undefined) {
        return (
          <Fragment key={anchorLink}>
            {sectionContent}
            <Container>
              <Row>
                {createItemsList(
                  currentSection.items,
                  menu,
                  menuIndex,
                  bookmarksEnabled
                )}
              </Row>
            </Container>
          </Fragment>
        );
      } else {
        return (
          <Fragment key={anchorLink}>
            {sectionContent}
            <Container>
              <Row>
                {createItemsList(
                  currentSection.items,
                  menu,
                  menuIndex,
                  bookmarksEnabled
                )}
              </Row>
            </Container>
            {currentSection.section.map((subSection) =>
              createSection(
                currentSection,
                subSection,
                menu,
                menuIndex,
                bookmarksEnabled
              )
            )}
          </Fragment>
        );
      }
    },
    [createItemsList, renderingStyleForText]
  );

  /**
   * Function to set the active Tab
   * @param {*} selectedTab
   */
  const tabSelect = (selectedTab) => {
    const { history } = props;
    setActiveTab(selectedTab);
    if (history.location.hash !== "") {
      history.location.hash = "";
    }

    // window.history.pushState("", "", "#");
  };

  const backToToc = (e) => {
    // prevent onclick event propagating up to parent components, and only act on the href onclick event
    e.stopPropagation();

    const { history, selectedMenu } = props;
    // Clear search value and render the original list
    setActiveTab("toc");
    history.push(`/${selectedMenu}`);
  };

  const refresh = () => {
    if (navigator.onLine) {
      window.location.reload();
    }
  };

  useEffect(() => {
    if (props?.menuItemIndex?.toString() && activeTab !== "menuSection") {
      setActiveTab("menuSection");
    }
  }, [props.menuItemIndex, activeTab, props]);

  const findCurrentMenu = props.listMenus.find(
    (menu) => menu.id === props.selectedMenu
  );

  /**
   * Get current selected menu
   */
  const menu = findCurrentMenu
    ? {
        name: findCurrentMenu.name,
        id: findCurrentMenu.id,
        menuLayout: findCurrentMenu?.menuLayout || "DEFAULT",
      }
    : {
        name: "Menu",
        id: "single_menu",
        menuLayout: findCurrentMenu?.menuLayout || "DEFAULT",
      };

  return (
    <>
      <Container style={{ marginBottom: "74px" }}>
        {(props.listMenus.length <= 1 ||
          (props.menuItemIndex !== null &&
            props.menuItemIndex !== undefined)) && (
          <div
            className="d-flex mt-3 mb-2 justify-content-between align-items-center"
            aria-label="Tabs"
          >
            <div className="tab">
              <div
                className={`tab-content ${activeTab === "toc" ? "active" : ""}`}
                onClick={backToToc}
              >
                Table of Contents
              </div>
              {!props.menuItemIndex && (
                <div
                  className={`tab-content ${
                    activeTab === "menu" ? "active" : ""
                  }`}
                  onClick={() => tabSelect("menu")}
                >
                  {props.listMenus.length === 1
                    ? props.listMenus[0].name
                    : "List"}
                </div>
              )}
            </div>
            {props.bookmarksEnabled && (
              <Link to="/bookmark">
                <BookMarkListIcon />
              </Link>
            )}
          </div>
        )}

        {/* Table of Contents tab */}
        <div
          className={activeTab === "toc" ? "" : "hidden"}
          event-key="toc"
          aria-label="Table of Contents tab"
        >
          <TableOfContentTab
            tocList={props.tocList}
            renderingStyleForText={renderingStyleForText}
            history={props.history}
            menuId={menu.id}
          />
        </div>

        {props.menuItemIndex !== null && props.menuItemIndex !== undefined ? (
          /* Menu section tab */
          <div
            event-key="menu"
            className={activeTab === "menuSection" ? "" : "hidden"}
            aria-label="List menu tab"
          >
            <MenuListDetailTab
              tocList={
                props.tocList[props.menuItemIndex]
                  ? [props.tocList[props.menuItemIndex]]
                  : []
              }
              fullJson={props.fullJson}
              activeTab={activeTab}
              loadSectionOnly={props.loadSectionOnly}
            >
              {(displayList) => {
                return (
                  <>
                    {displayList !== undefined &&
                      displayList.map((section, index) => {
                        return (
                          section && (
                            <Fragment key={section.title + "-" + index}>
                              <Row
                                variant="flush"
                                data-testid="wine-list"
                                aria-label="Menu List"
                              >
                                {createSection(
                                  undefined,
                                  section,
                                  menu,
                                  props.menuItemIndex,
                                  props.bookmarksEnabled
                                )}
                              </Row>
                            </Fragment>
                          )
                        );
                      })}
                  </>
                );
              }}
            </MenuListDetailTab>
          </div>
        ) : (
          /* List menu tab */
          <div
            event-key="menu-section"
            className={activeTab === "menu" ? "" : "hidden"}
            aria-label="List menu section tab"
          >
            <MenuListDetailTab
              tocList={props.tocList}
              fullJson={props.fullJson}
              activeTab={activeTab}
              loadSectionOnly={props.loadSectionOnly}
            >
              {(displayList) => {
                return (
                  <>
                    {displayList !== undefined &&
                      displayList.map((section, index) => {
                        return section ? (
                          <Fragment key={section.title + "-" + index}>
                            <Row
                              variant="flush"
                              data-testid="wine-list"
                              aria-label="Menu List"
                            >
                              {createSection(
                                undefined,
                                section,
                                menu,
                                index,
                                props.bookmarksEnabled
                              )}
                            </Row>
                          </Fragment>
                        ) : null;
                      })}
                  </>
                );
              }}
            </MenuListDetailTab>
          </div>
        )}

        <Navbar
          style={{ width: "20px" }}
          bg="transparent"
          fixed="bottom"
          role="navigation"
          aria-label="Secondary navigation"
        >
          <ButtonGroup aria-label="actions" size="sm">
            {activeTab !== "toc" && (
              <Button
                variant="dark font-weight-bold"
                onClick={backToToc}
                aria-label="Back to Table of Contents button"
                title="Table of Contents"
              >
                Table of Contents
              </Button>
            )}
            <Button
              variant="dark"
              onClick={scrollToTop}
              aria-label="Scroll to Top Button"
              title="Scroll to top"
            >
              <span className="visually-hidden">Scroll to top</span>
              <FiArrowUp aria-label="Up arrow icon" />
            </Button>
          </ButtonGroup>
        </Navbar>
      </Container>
      {activeTab !== "menu" && (
        <ButtonGroup
          aria-label="actions"
          size="sm"
          className="position-absolute pt-2 pr-3"
          style={{
            top: 0,
            right: 0,
            zIndex: 1030,
          }}
        >
          <Button
            variant="dark"
            onClick={refresh}
            aria-label="Button"
            title="Refresh"
          >
            <span className="visually-hidden">Refresh</span>
            <FiRefreshCw aria-label="Refresh icon" />
          </Button>
        </ButtonGroup>
      )}
    </>
  );
});

export default withRouter(DisplayMenu);
